import { Button, styled, ButtonProps } from '@mui/material'
import { CSSProperties } from 'react'

/**
 * Custom styled button component using MUI's styled API.
 */
const StyledButton = styled(Button)(({ theme, color, disabled }) => {
  const style: Partial<CSSProperties> & Record<string, any> = {
    borderRadius: theme.spacing(3),
    textTransform: 'none',
    padding: theme.spacing(1),
    paddingInline: theme.spacing(2),
    gap: theme.spacing(1),

    ':disabled': {
      color: theme.palette.action.disabled,
      background: theme.palette.action.disabledBackground,
      borderColor: theme.palette.action.disabledBackground
    }
  }

  if (!color) {
    return {
      ...style,
      '&:not(.MuiButton-outlined):not(.Mui-disabled)': {
        color: theme.palette.primarySoft.contrastText,
        background: theme.palette.primarySoft.main
      },
      '&.MuiButton-outlined:not(.Mui-disabled)': {
        color: theme.palette.primarySoft.main,
        borderColor: theme.palette.primarySoft.main,
        background: theme.palette.background.default
      }
    }
  }

  return style
})

/**
 * Button component with custom styles
 * This component is styled using MUI's styled API.
 *
 * @param {ButtonProps} props - The properties for the button component.
 * @returns {JSX.Element} Returns a styled button component.
 */
const ButtonBase = (props: ButtonProps) => {
  return <StyledButton {...props} />
}

export default ButtonBase
